export default __webpack_public_path__ + "static/media/aichat.a2f476d7.png";